import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpResponse,
	HTTP_INTERCEPTORS
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ConstantsService } from '../services/constant/constants.service';
import { CacheService } from '../services/cache/cache.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
	constant: ConstantsService = new ConstantsService();
	private host: string = this.constant.backendUrl;

	constructor(private cacheService: CacheService) {}

	intercept(
		req: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		if (req.method !== 'GET') {
			this.cacheService.clearCache();
			return next.handle(req);
		}

		if (req.url.includes(`${this.host}/user/register`)) {
			return next.handle(req);
		}

		if (req.url.includes(`${this.host}/user/login`)) {
			return next.handle(req);
		}

		if (req.url.includes(`/page`)) {
			this.cacheService.clearCache();
		 	return next.handle(req);
		}

		if (req.url.includes(`${this.host}/evaluate`)) {
			this.cacheService.clearCache();
			return next.handle(req);
		}

		if (req.url.includes(`${this.host}/messages`)) {
			return next.handle(req);
		}
		if (req.url.includes(`${this.host}/notifications`)) {
			return next.handle(req);
		}

		if (req.url.includes(`${this.host}/route`)) {
			return next.handle(req);
		}

		if (req.url.includes(`validation`)) {
			return next.handle(req);
		}

		if (req.url.includes(`evaluate`)) {
			return next.handle(req);
		}

		if (req.url.includes(`build`)) {
			this.cacheService.clearCache();
			return next.handle(req);
		}

		if (req.url.includes(`report/tmp/choice`)) {
			this.cacheService.clearCache();
			return next.handle(req);
		}

		if (req.url.includes(`report/tmp`)) {
			return next.handle(req);
		}

		if (req.url.includes(`desaffecter`)) {
			this.cacheService.clearCache();
			return next.handle(req);
		}

		const cachedResponse: HttpResponse<any> = this.cacheService.getCache(
			req.url
		);

		if (cachedResponse) {
			return of(cachedResponse);
		}

		return next.handle(req).pipe(
			tap((event) => {
				if (event instanceof HttpResponse) {
					this.cacheService.cacheRequest(req.url, event);
				}
			})
		);
	}
}

export const cacheInterceptorProviders = [
	{ provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true }
];
